<script>
import appConfig from "@/app.config";
import axios from 'axios';

// 초기세팅
function initialState() {
  return {
    token: "",
    login: {
      idx: 0,
      level: 0,
      nick: "",
      isLogin: false,
    },
    modifyInfo: {
      base: {}
    }
  };
}

export default {
  components: {
  },
  data() {
    return initialState();
  },
  props: {
    selectedMenu: {
      type: String,
    },
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.first()
  },
  methods: {
    first() {
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
        // 레벨 98 이하거나 로그인 안한상태면 첫화면으로
        if (this.login.level < 98) {
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
          this.$router.push('/');
        } else {
          this.r_admin_basicinfo()
          this.getWebSiteInfoBase()
        }
      } else {
        this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
        this.$router.push('/');
      }
    },
    // 홈페이지 기본정보
    getWebSiteInfoBase() {
      this.baseInfo = this.$store.getters.getWebSiteInfoBase
    },
    // 관리페이지 기본설정
    async r_admin_basicinfo() {
      try {
        this.loadingBar(true)
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/r_admin_basicinfo',
          headers: {
            'access-token': this.token
          },
          data: {
            "mb_idx": this.login.idx,
            "mb_level": this.login.level,
          },
        })
        .then((res) => {
          if (res.data) {
            if (res.data.baseData) {
              this.modifyInfo.base = res.data.baseData
            }
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의2'+error })
      } finally {
        this.loadingBar(false)
      }
    },   
    // 기다려주세요 loading 처리
    loadingBar(val) {
      this.$nextTick(() => {
        const preloader = document.getElementById("preloader");
        const status = document.getElementById("status");
        
        if (preloader && status) {
          if (val === true) {
            preloader.style.display = "block";
            status.style.display = "block";
          } else {
            preloader.style.display = "none";
            status.style.display = "none";
          }
        }
      });
    }, 
    sendModifyBaseData() {
      if (this.modifyInfo.base.longName !=='' && this.modifyInfo.base.shortName !=='' && 
      this.modifyInfo.base.fax1Number !=='' && this.modifyInfo.base.address !=='' &&
      this.modifyInfo.base.office1Name !=='' && this.modifyInfo.base.office1Number !=='' && 
      this.modifyInfo.base.office2Name !=='' && this.modifyInfo.base.office2Number !=='' &&
      this.modifyInfo.base.facebook !=='' && this.modifyInfo.base.instagram !=='' && this.modifyInfo.base.index_topmessage_title !=='' &&
      this.modifyInfo.base.index_topmessage[0] !=='' && this.modifyInfo.base.index_topmessage[1] !=='' && this.modifyInfo.base.index_topmessage[2] !=='') {
        this.m_basedata_modify()
      } else {
        this.$notify({ type: 'error', duration: 2000, title: '실패', text: '모든 칸을 채워주세요' })
      }
    },
    // 기본 설정 수정 저장하자
    async m_basedata_modify() {
      try {

        this.loadingBar(true)
        if (this.modifyInfo.base.longName !=='' && this.modifyInfo.base.shortName !=='') {
          await axios({
            method: 'POST',
            url: appConfig.fastapi + '/auth/m_basedata_modify',
            headers: {
              'access-token': this.token
            },
            data: {
              "emailAddress": this.modifyInfo.base.emailAddress,
              "smsAddress": this.modifyInfo.base.smsAddress,
              "appKey": this.modifyInfo.base.appKey,
              "secretKey": this.modifyInfo.base.secretKey,
              "alrim1": this.modifyInfo.base.alrim1,
              "alrim2": this.modifyInfo.base.alrim2,
              "alrim3": this.modifyInfo.base.alrim3,
              "alrim4": this.modifyInfo.base.alrim4,
              "alrim5": this.modifyInfo.base.alrim5,
              "alrim6": this.modifyInfo.base.alrim6,
              "alrim_appKey": this.modifyInfo.base.alrim_appKey,
              "alrim_secretKey": this.modifyInfo.base.alrim_secretKey,
              "alrim_senderKey": this.modifyInfo.base.alrim_senderKey,
              "alrim_templateCode": this.modifyInfo.base.alrim_templateCode,
              "contactAddress": this.modifyInfo.base.contactAddress,
              "longName": this.modifyInfo.base.longName,
              "shortName": this.modifyInfo.base.shortName,
              "fax1Number": this.modifyInfo.base.fax1Number,
              "bankName": this.modifyInfo.base.bankName,
              "accountHolder": this.modifyInfo.base.accountHolder,
              "accountNumber": this.modifyInfo.base.accountNumber,
              "address": this.modifyInfo.base.address,
              "office1Name": this.modifyInfo.base.office1Name,
              "office1Number": this.modifyInfo.base.office1Number,
              "office2Name": this.modifyInfo.base.office2Name,
              "office2Number": this.modifyInfo.base.office2Number,
              "sns1": this.modifyInfo.base.sns1,
              "sns2": this.modifyInfo.base.sns2,
              "sns3": this.modifyInfo.base.sns3,
              "sns4": this.modifyInfo.base.sns4,
              "index_topmessage_title": this.modifyInfo.base.index_topmessage_title,
              "index_topmessage": this.modifyInfo.base.index_topmessage,
            },
          })
          .then((res) => {
            if (res.data.type == 'success') {
              // store에 수정된거 저장하자
              this.$store.commit('setWebSiteInfoBase', this.modifyInfo.base);
              // 새로고침
              this.$router.go(0);
            } else {
              this.$notify({ type: 'error', duration: 3000, 'title': res.data.status+' 에러', text: res.data.detail })
            }
          })
          .catch((error) => {
            console.log(error)
            if (error.response) {
              this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
            }
          })
          .finally(()=> {
            // 
          })
        }
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의3'+error })
      } finally {
        this.loadingBar(false)
      }
    },
    // 기다려주세요 loading 처리
    loadingBar(val) {
      this.$nextTick(() => {
        const preloader = document.getElementById("preloader");
        const status = document.getElementById("status");
        
        if (preloader && status) {
          if (val === true) {
            preloader.style.display = "block";
            status.style.display = "block";
          } else {
            preloader.style.display = "none";
            status.style.display = "none";
          }
        }
      });
    },
  },
}
</script>

<template>
  <div v-show="modifyInfo">
    <div class="rounded shadow">
      <div id="loading-area" class="p-4 border-bottom">
        <h5 class="text-md-left text-center">기본 설정</h5>
        <div>
          <div class="row">
            <div v-if="login.level == 99" class="col-sm-12">
              <button class="btn btn-lg btn-block btn-blue" @click="sendModifyBaseData()">저장하기</button>
            </div>
            <div v-else class="col-sm-12">
              <button class="btn btn-lg btn-block btn-blue" disabled>최고관리자만 저장가능합니다.</button>
            </div>
          </div>
          <div v-if="modifyInfo.base" class="row mt-4">

            <!-- 문자전송 관련 설정 -->
            <div class="col-md-12 mb-4">
              <div class="card">
                <div class="card-header">
                  <span class="font-size-12 text-secondary admin-label">문자전송 관련 설정 (1건당 SMS 9.9원, LMS 30원, MMS 100원 vat별도)</span>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- 문자 전송시 발신번호 -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="smsAddress" v-b-tooltip.hover.right title="문자메세지 전송할 때 사용할 발신번호를 입력해주세요" class="text-secondary font-size-12 mb-1">
                          문자전송 발신번호 <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="smsAddress"
                            id="smsAddress"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12"
                            v-model="modifyInfo.base.smsAddress"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <!-- NHN Cloud appKey -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="appKey" v-b-tooltip.hover.right title="toast.com 로그인 후 콘솔에서 프로젝트-hi 선택하고 Notification - SMS에서 우측 위 URL & AppKey 항목 확인" class="text-secondary font-size-12 mb-1">
                          문자전송 AppKey <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="appKey"
                            id="appKey"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12 border-warning"
                            v-model="modifyInfo.base.appKey"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <!-- NHN Cloud secretKey -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="secretKey" v-b-tooltip.hover.right title="toast.com 로그인 후 콘솔에서 프로젝트-hi 선택하고 Notification - SMS에서 우측 위 URL & AppKey 항목 확인" class="text-secondary font-size-12 mb-1">
                          문자전송 SecretKey <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="secretKey"
                            id="secretKey"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12 border-warning"
                            v-model="modifyInfo.base.secretKey"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 알림톡 설정 -->
            <div class="col-md-12 mb-4">
              <div class="card">
                <div class="card-header">
                  <span class="font-size-12 text-secondary admin-label">새 상담글 알림톡 설정 (1건당 알림톡 7.9원 vat별도)</span>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- 알림톡 수신번호 1 -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="alrim_recipientList1" v-b-tooltip.hover.right title="알림톡 받을 수신번호 1을 입력해주세요. 여러명이 수신할거면 뒤에 칸들 채워주세요" class="text-secondary font-size-12 mb-1">
                          알림톡 받을 수신번호 1 <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="alrim_recipientList1"
                            id="alrim_recipientList1"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12"
                            v-model="modifyInfo.base.alrim1"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <!-- 알림톡 수신번호 2 -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="alrim_recipientList2" v-b-tooltip.hover.right title="알림톡 받을 수신번호 2을 입력해주세요. 필요없으면 비워주세요" class="text-secondary font-size-12 mb-1">
                          알림톡 받을 수신번호 2 <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="alrim_recipientList2"
                            id="alrim_recipientList2"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12"
                            v-model="modifyInfo.base.alrim2"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <!-- 알림톡 수신번호 3 -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="alrim_recipientList3" v-b-tooltip.hover.right title="알림톡 받을 수신번호 3을 입력해주세요. 필요없으면 비워주세요" class="text-secondary font-size-12 mb-1">
                          알림톡 받을 수신번호 3 <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="alrim_recipientList3"
                            id="alrim_recipientList3"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12"
                            v-model="modifyInfo.base.alrim3"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <!-- 알림톡 수신번호 4 -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="alrim_recipientList4" v-b-tooltip.hover.right title="알림톡 받을 수신번호 4을 입력해주세요. 필요없으면 비워주세요" class="text-secondary font-size-12 mb-1">
                          알림톡 받을 수신번호 4 <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="alrim_recipientList4"
                            id="alrim_recipientList4"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12"
                            v-model="modifyInfo.base.alrim4"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <!-- 알림톡 수신번호 5 -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="alrim_recipientList5" v-b-tooltip.hover.right title="알림톡 받을 수신번호 5을 입력해주세요. 필요없으면 비워주세요" class="text-secondary font-size-12 mb-1">
                          알림톡 받을 수신번호 5 <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="alrim_recipientList5"
                            id="alrim_recipientList5"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12"
                            v-model="modifyInfo.base.alrim5"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <!-- 알림톡 수신번호 6 -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="alrim_recipientList6" v-b-tooltip.hover.right title="알림톡 받을 수신번호 6을 입력해주세요. 필요없으면 비워주세요" class="text-secondary font-size-12 mb-1">
                          알림톡 받을 수신번호 6 <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="alrim_recipientList6"
                            id="alrim_recipientList6"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12"
                            v-model="modifyInfo.base.alrim6"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <!-- 알림톡 SenderKey -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="alrim_senderKey" v-b-tooltip.hover.right title="알림톡 발신자 키를 입력해주세요." class="text-secondary font-size-12 mb-1">
                          알림톡 SenderKey <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="alrim_senderKey"
                            id="alrim_senderKey"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12 border-warning"
                            v-model="modifyInfo.base.alrim_senderKey"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <!-- 알림톡 alrim_templateCode -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="alrim_templateCode" v-b-tooltip.hover.right title="알림톡 템플릿 코드를 입력해주세요." class="text-secondary font-size-12 mb-1">
                          알림톡 템플릿 코드 <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="alrim_templateCode"
                            id="alrim_templateCode"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12 border-warning"
                            v-model="modifyInfo.base.alrim_templateCode"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <!-- 알림톡 AppKey -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="alrim_appKey" v-b-tooltip.hover.right title="toast.com 로그인 후 콘솔에서 프로젝트-hi 선택하고 Notification - KakaoTalk Bizmessage에서 우측 위 URL & AppKey 항목 확인" class="text-secondary font-size-12 mb-1">
                          알림톡 AppKey <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="alrim_appKey"
                            id="alrim_appKey"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12 border-warning"
                            v-model="modifyInfo.base.alrim_appKey"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <!-- 알림톡 SecretKey -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="alrim_secretKey" v-b-tooltip.hover.right title="toast.com 로그인 후 콘솔에서 프로젝트-hi 선택하고 Notification - KakaoTalk Bizmessage에서 우측 위 URL & AppKey 항목 확인" class="text-secondary font-size-12 mb-1">
                          알림톡 SecretKey <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="alrim_secretKey"
                            id="alrim_secretKey"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12 border-warning"
                            v-model="modifyInfo.base.alrim_secretKey"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 메일전송 설정 -->
            <div class="col-md-12 mb-4">
              <div class="card">
                <div class="card-header">
                  <span class="font-size-12 text-secondary admin-label">메일전송 설정</span>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- 이메일 전송시 발송이메일주소 -->
                    <div class="col-md-4">
                      <div class="">
                        <label for="emailAddress" v-b-tooltip.hover.right title="이메일 전송시 발송 이메일주소를 입력해주세요" class="text-secondary font-size-12 mb-1">
                          발신 이메일주소 <i class="mdi mdi-comment-question"></i>
                        </label>
                        <div class="position-relative">
                          <input
                            name="emailAddress"
                            id="emailAddress"
                            type="text"
                            class="form-control form-control-sm text-bold text-dark font-size-12"
                            v-model="modifyInfo.base.emailAddress"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 기본 설정 -->
            <div class="col-md-12 mb-4">
              <div class="card">
                <div class="card-header">
                  <span class="font-size-12 text-secondary admin-label">기본 설정</span>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- 기본 -->
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="longName" class="text-secondary admin-label">홈페이지이름 길게</label>
                        <div class="position-relative">
                          <input
                            name="longName"
                            id="longName"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.longName"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="shortName" class="text-secondary admin-label">홈페이지이름 짧게</label>
                        <div class="position-relative">
                          <input
                            name="shortName"
                            id="shortName"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.shortName"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="office1Name" class="text-secondary admin-label">사무실1 이름</label>
                        <div class="position-relative">
                          <input
                            name="office1Name"
                            id="office1Name"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.office1Name"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="office1Number" class="text-secondary admin-label">사무실1 전화</label>
                        <div class="position-relative">
                          <input
                            name="office1Number"
                            id="office1Number"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.office1Number"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="office2Name" class="text-secondary admin-label">사무실2 이름</label>
                        <div class="position-relative">
                          <input
                            name="office2Name"
                            id="office2Name"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.office2Name"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="office2Number" class="text-secondary admin-label">사무실2 전화</label>
                        <div class="position-relative">
                          <input
                            name="office2Number"
                            id="office2Number"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.office2Number"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="baseAddress" class="text-secondary admin-label">기본주소</label>
                        <div class="position-relative">
                          <input
                            name="baseAddress"
                            id="baseAddress"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.address"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="fax1Number" class="text-secondary admin-label">팩스</label>
                        <div class="position-relative">
                          <input
                            name="fax1Number"
                            id="fax1Number"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.fax1Number"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="bankName" class="text-secondary admin-label">후원계좌 은행명</label>
                        <div class="position-relative">
                          <input
                            name="bankName"
                            id="bankName"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.bankName"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="accountHolder" class="text-secondary admin-label">후원계좌 예금주</label>
                        <div class="position-relative">
                          <input
                            name="accountHolder"
                            id="accountHolder"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.accountHolder"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="accountNumber" class="text-secondary admin-label">후원계좌 계좌번호</label>
                        <div class="position-relative">
                          <input
                            name="accountNumber"
                            id="accountNumber"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.accountNumber"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 첫페이지 설정 -->
            <div class="col-md-12 mb-4">
              <div class="card">
                <div class="card-header">
                  <span class="font-size-12 text-secondary admin-label">첫페이지 설정</span>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- 첫페이지 상단 문구 -->
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="index_topmessage_title" class="text-secondary admin-label">첫페이지 고정 텍스트</label>
                        <div class="position-relative">
                          <input
                            name="index_topmessage_title"
                            id="index_topmessage_title"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.index_topmessage_title"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div v-if="modifyInfo.base.index_topmessage" class="form-group">
                        <label for="topmessage0" class="text-secondary admin-label">상단 텍스트 1</label>
                        <div class="position-relative">
                          <input
                            name="topmessage0"
                            id="topmessage0"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.index_topmessage[0]"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div v-if="modifyInfo.base.index_topmessage" class="form-group">
                        <label for="topmessage1" class="text-secondary admin-label">상단 텍스트 2</label>
                        <div class="position-relative">
                          <input
                            name="topmessage1"
                            id="topmessage1"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.index_topmessage[1]"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div v-if="modifyInfo.base.index_topmessage" class="form-group">
                        <label for="topmessage2" class="text-secondary admin-label">상단 텍스트 3</label>
                        <div class="position-relative">
                          <input
                            name="topmessage2"
                            id="topmessage2"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.index_topmessage[2]"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            

            <!-- SNS 설정 -->
            <div class="col-md-12 mb-4">
              <div class="card">
                <div class="card-header">
                  <span class="font-size-12 text-secondary admin-label">SNS 설정</span>
                </div>
                <div class="card-body">
                  <div class="row">
                    
                    <!-- SNS -->
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="facebook" class="text-secondary admin-label">페이스북 url</label>
                        <div class="position-relative">
                          <input
                            name="facebook"
                            id="facebook"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.sns1"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="instagram" class="text-secondary admin-label">인스타그램 url</label>
                        <div class="position-relative">
                          <input
                            name="instagram"
                            id="instagram"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.sns2"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="kakao" class="text-secondary admin-label">카카오채널 url</label>
                        <div class="position-relative">
                          <input
                            name="kakao"
                            id="kakao"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.sns3"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="twitter" class="text-secondary admin-label">트위터 url</label>
                        <div class="position-relative">
                          <input
                            name="twitter"
                            id="twitter"
                            type="text"
                            class="form-control text-bold text-dark"
                            v-model="modifyInfo.base.sns4"
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            

          </div>
          <div class="row">
            <div v-if="login.level == 99" class="col-sm-12">
              <button class="btn btn-lg btn-block btn-blue" @click="sendModifyBaseData()">저장하기</button>
            </div>
            <div v-else class="col-sm-12">
              <button class="btn btn-lg btn-block btn-blue" disabled>최고관리자만 저장가능합니다.</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>